import type { CardStyle, CardStyleColors } from '../models/card-model';
import type { CardStyleColorsInput } from '../graphql/mutations/update-card-with-version';

/** Clears persisted per-card color overrides (API treats null as delete). */
const CARD_COLOR_CLEAR = {
	background: null,
	border: null,
	shadow: null,
} as const;

/**
 * GraphQL patch fragment that clears light/dark card color overrides.
 * `updateCard` deep-merges style; `{}` does not remove nested colors — explicit nulls do.
 */
export function cardStyleColorsClearPatch(): CardStyleColors {
	return {
		light: { card: { ...CARD_COLOR_CLEAR } },
		dark: { card: { ...CARD_COLOR_CLEAR } },
	};
}

export function cardStyleColorsClearGqlInput(): CardStyleColorsInput {
	return cardStyleColorsClearPatch() as unknown as CardStyleColorsInput;
}

/**
 * Style patch for "Reset to Report Theme": clear colors, optionally keep layout props.
 */
export function cardStyleResetColorsPatch(
	layoutCard?: CardStyle['card']
): CardStyle {
	const colors = cardStyleColorsClearPatch();
	if (layoutCard && Object.keys(layoutCard).length > 0) {
		return { card: { ...layoutCard }, colors };
	}
	return { colors };
}
